<div class="search-panel">
    <div class="panel-header">
        <h3 class="panel-title">Search Filters</h3>
    </div>
    <form class="search-form">
        <div class="search-fields">
            <!-- Date From -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="unified-date-field"
                >
                    <mat-label>Date From (DD/MM/YYYY)</mat-label>
                    <input
                        matInput
                        [matDatepicker]="dateFromPicker"
                        [(ngModel)]="searchFilters.dateFrom"
                        name="dateFrom"
                        placeholder="DD/MM/YYYY"
                        #dateFromInput="ngModel"
                        [errorStateMatcher]="noErrorMatcher"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="dateFromPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dateFromPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Date To -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="unified-date-field"
                >
                    <mat-label>Date To (DD/MM/YYYY)</mat-label>
                    <input
                        matInput
                        [matDatepicker]="dateToPicker"
                        [(ngModel)]="searchFilters.dateTo"
                        name="dateTo"
                        placeholder="DD/MM/YYYY"
                        #dateToInput="ngModel"
                        [errorStateMatcher]="noErrorMatcher"
                    />
                    <mat-datepicker-toggle
                        matSuffix
                        [for]="dateToPicker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #dateToPicker></mat-datepicker>
                </mat-form-field>
            </div>

            <!-- Status -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>Status</mat-label>
                    <mat-select
                        [(ngModel)]="searchFilters.status"
                        name="status"
                    >
                        <mat-option value="">All</mat-option>
                        <mat-option value="1">Won</mat-option>
                        <mat-option value="0">Lost</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            <!-- User UUID -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>User UUID</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchFilters.userUuid"
                        name="userUuid"
                        placeholder="Enter user UUID"
                    />
                </mat-form-field>
            </div>

            <!-- Ticket UUID -->
            <div class="field-group">
                <mat-form-field
                    appearance="fill"
                    class="minimal-field"
                >
                    <mat-label>Ticket UUID</mat-label>
                    <input
                        matInput
                        [(ngModel)]="searchFilters.ticketUuid"
                        name="ticketUuid"
                        placeholder="Enter ticket UUID"
                    />
                </mat-form-field>
            </div>
        </div>

        <div class="search-actions">
            <button
                mat-flat-button
                color="primary"
                (click)="onSearch()"
                type="button"
                class="search-btn"
            >
                <mat-icon>search</mat-icon>
                Search
            </button>
            <button
                mat-stroked-button
                (click)="onClear()"
                type="button"
                class="clear-btn"
            >
                <mat-icon>clear</mat-icon>
                Clear
            </button>
        </div>
    </form>
</div>
